import React from 'react';
import GlobalWrapper from 'components/global-wrapper/component';
export default function WrapperItems() {
    return (React.createElement(GlobalWrapper, null));
}
